var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"centerpopcontainer"}},[_vm._l((_vm.pops),function(child){return [_c(child.pop,{key:child.id,tag:"component"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }